/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Broker_Status_UpdatedInputs */

const cs_ebr_broker_status_updated = /** @type {(inputs: Ebr_Broker_Status_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualizace`)
};

const en_ebr_broker_status_updated = /** @type {(inputs: Ebr_Broker_Status_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update`)
};

/**
* | output |
* | --- |
* | "Update" |
*
* @param {Ebr_Broker_Status_UpdatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_broker_status_updated = /** @type {((inputs?: Ebr_Broker_Status_UpdatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Broker_Status_UpdatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_broker_status_updated(inputs)
	return cs_ebr_broker_status_updated(inputs)
});